import React from 'react';
import styles from './index.css';
import { wapactPageCount } from 'ThreeTerminal_utils';
import { callApp } from '@ifeng-fe/callapp';
import PropTypes from 'prop-types';

class CallupHead extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };

    header = React.createRef();

    state = {
        isClose: true,
        keyword: '',
        isShowAppIcon: false,
    };

    androidAppIconHandle = () => {
        const UA = navigator.userAgent.toLocaleLowerCase();

        if (UA.toLocaleLowerCase().match(/android/) && /micromessenger/i.test(UA)) {
            this.setState({
                isShowAppIcon: false,
            });
        } else {
            this.setState({
                isShowAppIcon: true,
            });
        }
        
        setTimeout(() => {
            if (!this.state.isShowAppIcon) {
                this.setState({
                    isShowAppIcon: true,
                });
            }
        }, 3000);
    };

    componentDidMount() {
        const { pageInfo, hotKeyword } = this.props.content;

        this.androidAppIconHandle();
        if (hotKeyword) {
            const keywordStr = hotKeyword[Math.floor(Math.random() * hotKeyword.length)];

            this.setState({
                keyword: keywordStr,
            });
        }

        if (pageInfo) {
            this.isHideFn();
        }
    }

    handleClick = (
        url,
        id,
        newstype,
        userId,
        others,
        position,
        downloads,
    ) => {
        const { topClickInfo, pageInfo } = this.props.content;
        const doc_type = newstype;
        const aid = pageInfo.base62Id || pageInfo.id;

        wapactPageCount({
            value: topClickInfo?.actionName,
            method: 'get',
        });

        callApp({
            docType: doc_type,
            pid: aid,
            kind: topClickInfo.callupKind,
            download: downloads.download,
            downloadAd: downloads.downloadAd,
            noKindFrom: pageInfo?.noKindFrom || 0,
        });
    };

    isHideFn() {
        const headerHeight = (this.header.current && this.header.current.offsetHeight) || 0;
        const srcollBox = document.body.scrollTop || (document.documentElement && document.documentElement.scrollTop);
        let beforeScrollTop = srcollBox || 0;
        let stausDown = true;
        let stausUp = true;
        let isScroll = true;
        let isTop = true;

        window.addEventListener(
            'scroll',
            () => {
                // if (!isScroll) return false;
                const afterScrollTop =
                    document.body.scrollTop || (document.documentElement && document.documentElement.scrollTop) || 0;
                const delta = afterScrollTop && afterScrollTop - beforeScrollTop;

                if (isTop && ((afterScrollTop && afterScrollTop <= headerHeight) || afterScrollTop === 0)) {
                    isTop = false;
                    setTimeout(() => {
                        isScroll = true;
                    }, 300);
                    this.setState({
                        isClose: true,
                    });

                    return false;
                } else if (afterScrollTop && afterScrollTop > headerHeight) {
                    isTop = true;
                }

                if (delta === 0 || (afterScrollTop && afterScrollTop <= headerHeight)) {
                    return false;
                }

                if (delta && delta > 0 && stausUp) {
                    stausDown = true;
                    stausUp = false;
                    isScroll = false;

                    setTimeout(() => {
                        isScroll = true;
                    }, 300);
                    this.setState({
                        isClose: true,
                    });
                    // console.log('向下');
                } else if (delta && delta < 0 && stausDown) {
                    stausUp = true;
                    stausDown = false;
                    isScroll = false;

                    setTimeout(() => {
                        isScroll = true;
                    }, 300);
                    this.setState({
                        isClose: false,
                    });
                    // console.log('向上');
                }

                beforeScrollTop = afterScrollTop;

                return false;
            },
            false,
        );
    }

    clickFixedFn = () => {
        this.setState({
            isClose: true,
        });
    };

    /**
     * 渲染网页布局
     */
    render() {
        /**
         * 组件分发数据
         */
        const {
            pageInfo,
            hotKeyword,
            isVideoShare,
            maxWidth,
        } = this.props.content;
        const { isClose, keyword, isShowAppIcon } = this.state;
        const maxWidthStyle = maxWidth
            ? {
                  maxWidth: `${maxWidth}`,
              }
            : {};

        return (
            <React.Fragment>
                <header ref={this.header} className={styles.header}>
                    <a
                        onClick={this.handleClick.bind(
                            this,
                            pageInfo.url,
                            pageInfo.id,
                            pageInfo.type,
                            pageInfo.userId,
                            pageInfo.others,
                            1,
                            pageInfo.downloads,
                        )}
                        href="javascript:;"
                        className={styles.headerBox}>
                        <span className={`${styles.logo} ${isVideoShare && styles.videoLogo}`} />
                        {isShowAppIcon && <span className={styles.botton}>立即打开</span>}
                    </a>
                </header>
                {hotKeyword && (
                    <header style={maxWidthStyle} className={!isClose ? styles.headerIn : styles.headerOut}>
                        <a
                            onClick={this.handleClick.bind(
                                this,
                                pageInfo.url,
                                pageInfo.id,
                                pageInfo.type,
                                pageInfo.userId,
                                pageInfo.others,
                                2,
                                pageInfo.downloads,
                            )}
                            href="javascript:;"
                            className={styles.info}>
                            <h3 className={styles.title}>{keyword}</h3>
                            {isShowAppIcon && <span className={styles.openBtn}>打开</span>}
                        </a>
                        <a href="javascript:;" onClick={this.clickFixedFn} className={styles.close} />
                    </header>
                )}
            </React.Fragment>
        );
    }
}

export default CallupHead;
